import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Home.css';  // 新增的CSS文件

const Home = () => {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = '首頁';
    const fetchCategories = async () => {
      try {
        const response = await axios.get('https://shopapi.nogi46.me/api/categories');
        setCategories(response.data);
      } catch (error) {
        setError('無法獲取分類，請稍後再試。');
      }
    };

    fetchCategories();
  }, []);

  return (
    <Container>
      {error && <Alert variant="danger">{error}</Alert>}
      <Row>
        {categories.map((category) => (
          <Col key={category.categoryId} xs={12} sm={6} md={4} lg={3} className="mb-4">
            <Card className="category-card">
              <Link to={`/category/${category.categoryId}`} className="category-link">
                <Card.Img variant="top" src={category.bannerImage} className="category-image" />
                <Card.Body className="category-body">
                  <Card.Title className="category-title">{category.name}</Card.Title>
                </Card.Body>
              </Link>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Home;
